export default {
  alertSystemHeader: {
    alertCode: 'alert Code',
    organCode: 'organCode',
    ticker: 'ticker',
    alertGroup: 'alertGroup',
    createDate: 'time',
    message: 'alert',
    notificationId: 'notificationId',
    status: 'status',
    title: 'title',
    alertName: 'Alerts',
  },
  button: {
    save: 'SAVE',
    cancel: 'CANCEL',
  },
  titlePopup: {
    setting: 'SETTING',
  },
};
